export const MICRO = 1_000_000;
export const BLOCKSPERYEAR = 4_656_810;
export const FEE = 0.02;
export const BANK_ACCOUNT = "ability assault moral trick shop motor announce force elite hazard crazy color fetch arena elbow world snap trade empower history fatigue border various bullet";
